'use client';

import React from 'react';
import styled from '@emotion/styled';
import { Logo, DesktopNavBase } from '../header';
import { colors, size, breakpoints } from "@argo/principles";
import { navbp, NAV_HEIGHT } from '../header/utils/constants';
import navigationFallback from './navigationFallback';
import { css, Global } from '@emotion/react';
import { rgba } from "@argo/utils";
import MyKBBHeaderContent from "./MyKBBHeaderContent";
import { Divider } from "@argo/ui-elements";
import MyWalletContent from './MyWalletContent';
const {
  primary
} = colors;
export const GlobalNavCss = css`
@media screen and (max-width: ${navbp.extraWideViewport}) {
  body.with-menu-open {
      position: fixed;
      &::after {
          content: '';
          position: fixed;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          z-index: 0;
          background: ${rgba(primary.black, .5)};
      }
      .content-with-effect {
          filter: blur(2px);
      }
  }
}
`;
const Header = styled('header')`
  display: flex;
  justify-content: center;
  background-color: ${primary.marineBlue};
  color: ${primary.white};
  height: ${NAV_HEIGHT}px;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100;

  @media (min-width: ${navbp.extraWideViewport}) {
    position: relative;
  }

  .expander-content {
    margin: 0 -${size.sm};
  }
  * {
    box-sizing: content-box;
  }
  @media print {
    display: none;
  }
`;
const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  > hr {
    display: none;
  }
  @media (min-width: ${navbp.extraWideViewport}) {
    > hr {
      display: block;
      height: 40%;
      margin-left: 0;
      margin-right: 0;
    }
  }
  @media (min-width: ${navbp.ipadLandscape}) {
    max-width: ${props => props.maxWidth || size.contentMaxWidth || 1280}px;
  }
`;
const MyWalletWrapper = styled('div')`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({
  withMyKbb
}) => withMyKbb ? 'padding: 26px 18px 20px 18px;' : 'padding: 26px 24px;'}
  
  @media (max-width: ${navbp.extraWideViewport}) {
    ${({
  withMyKbb
}) => withMyKbb ? 'padding: 26px 8px 20px 8px;' : ''}
    width: auto;
  }
`;
const MyKbbHeader = ({
  navigation,
  maxWidth,
  navMenuLegal,
  withMyKbb,
  suppressZipCode = false,
  showWallet = false,
  hasNewTradeIn = false,
  isLoggedIn,
  onWalletIconClick = () => {},
  totalWalletNotifs = 0,
  walletPopoverContainer,
  slimLittleGuy = false,
  pageId,
  useAuthRedirect = false
}) => {
  const isDataFromAPI = navigation && navigation.headerLinks && navigation.headerLinks.length > 0;
  const navLinks = isDataFromAPI ? navigation.headerLinks : navigationFallback.headerLinks;
  const addDividerComponent = withMyKbb || showWallet;
  return React.createElement(React.Fragment, null, React.createElement(Global, {
    styles: css`
            body.with-menu-open {
              overflow: hidden;
              width: 100%;
              position: fixed;
            }

            @media (min-width: ${navbp.extraWideViewport}) {
              body.with-menu-open {
                overflow: auto;
                width: 100%;
                position: relative;
              }
            }

            @media (max-width: ${navbp.extraWideViewport}) {
              .fixed-position-mobile-mode {
                  position: fixed;
              }

              .sticky-position-mobile-mode {
                  position: sticky;
                  height: 100%;
              }
            }
          `
  }), React.createElement(Header, {
    key: "header"
  }, React.createElement(HeaderWrapper, {
    maxWidth: maxWidth
  }, React.createElement(Logo, null), React.createElement(DesktopNavBase, {
    links: navLinks,
    withMyKbb: withMyKbb,
    isDataFromAPI: isDataFromAPI,
    pageId: pageId
  }), addDividerComponent && React.createElement(Divider, {
    vertical: true
  }), showWallet && React.createElement(MyWalletWrapper, {
    withMyKbb: withMyKbb
  }, React.createElement(MyWalletContent, {
    hasNewTradeIn: hasNewTradeIn,
    onWalletIconClick: onWalletIconClick,
    totalWalletNotifs: totalWalletNotifs,
    walletPopoverContainer: walletPopoverContainer
  })), withMyKbb && React.createElement(React.Fragment, null, React.createElement(Divider, {
    vertical: true
  }), React.createElement(MyKBBHeaderContent, {
    withMyKbb: withMyKbb,
    navMenuLegal: navMenuLegal,
    navLinks: navLinks,
    suppressZipCode: suppressZipCode,
    isLoggedIn: isLoggedIn,
    slimLittleGuy: slimLittleGuy,
    pageId: pageId,
    useAuthRedirect: useAuthRedirect
  })))));
};
MyKbbHeader.displayName = 'MyKbbHeader';
export default MyKbbHeader;